import React, { useMemo, useState } from "react";

// Utils
import { Form, FormGroup, Dropdown, Radio } from "semantic-ui-react";

// Common
import DateTextBox from "react-lib/apps/common/DateTextBox";
import ButtonLoadCheck from "react-lib/appcon/common/ButtonLoadCheck";
import { useIntl } from "react-intl";

// Constant
const PATIENT_TYPE: any[] = [
  { key: "OPD และ IPD", value: "OPD และ IPD", text: "OPD และ IPD" },
  { key: "OPD", value: "OPD", text: "OPD" },
  { key: "IPD", value: "IPD", text: "IPD" },
];

const CardClinicIncomeReportFilter = (props: any) => {
  const intl = useIntl();
  // useState
  const [requiredStartDate, setRequiredStartDate] = useState<boolean>(false);

  // UseMemo
  const coverageOptions = useMemo(() => {
    return [
      { key: "ทุกสิทธิ", value: "ทุกสิทธิ", text: "ทุกสิทธิ" },
      ...(props.masterOptions?.coverage || []),
    ];
  }, [props.masterOptions?.coverage]);

  const handleSelectRadio = (optionSelected: any) => {
    switch (optionSelected) {
      case "daily":
      case "monthly":
      case "yearly":
        return (
          props.ClinicAnnualReportSequence?.clinicIncomeReport?.reportType === `${optionSelected}`
        );
      default:
        console.warn("Option Doesn't Exist!!");
        break;
    }
  };

  const handleChangeRadio = (e: any, { value }: { value: string }) => {
    props.setProp(`ClinicAnnualReportSequence.clinicIncomeReport.reportType`, value);
  };

  const handlePreviewButton = () => {
    if (requiredStartDate) {
      alert("กรุณาระบุวันที่รับบริการ");
    } else {
      props.runSequence({
        sequence: "ClinicAnnualReport",
        action: "PREVIEW_REPORT",
        menu: "รายงานสรุปค่าใช้จ่ายผู้ป่วยเข้ารับบริการที่คลินิก",
      });
    }
  };

  const handlePrintButton = () => {
    if (requiredStartDate) {
      alert("กรุณาระบุวันที่รับบริการ");
    } else {
      props.runSequence({
        sequence: "ClinicAnnualReport",
        action: "PRINT_REPORT",
        menu: "รายงานสรุปค่าใช้จ่ายผู้ป่วยเข้ารับบริการที่คลินิก",
      });
    }
  };

  const handleDownloadButton = () => {
    if (requiredStartDate) {
      alert("กรุณาระบุวันที่รับบริการ");
    } else {
      props.runSequence({
        sequence: "ClinicAnnualReport",
        action: "DOWNLOAD_REPORT",
        menu: "รายงานสรุปค่าใช้จ่ายผู้ป่วยเข้ารับบริการที่คลินิก",
      });
    }
  };

  return (
    <Form>
      <FormGroup className="ui form" style={{ gap: "1rem", padding: "0rem 0rem 0rem 1rem" }}>
        <label style={{ display: "flex", alignItems: "center" }}>
          ประเภทรายงาน<span style={{ color: "red" }}>*</span>
        </label>
        <Radio
          label={intl.formatMessage({ id: "ประจำวัน" })}
          checked={handleSelectRadio("daily")}
          onChange={handleChangeRadio}
          value="daily"
          style={{ display: "flex", alignItems: "center" }}
        ></Radio>
        <Radio
          label={intl.formatMessage({ id: "จ่ายประจำเดือน" })}
          checked={handleSelectRadio("monthly")}
          onChange={handleChangeRadio}
          value="monthly"
          style={{ display: "flex", alignItems: "center" }}
        ></Radio>
        <Radio
          label={intl.formatMessage({ id: "ประจำปี" })}
          checked={handleSelectRadio("yearly")}
          onChange={handleChangeRadio}
          value="yearly"
          style={{ display: "flex", alignItems: "center" }}
        ></Radio>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            padding: "0rem 5.85rem 0rem 0rem",
          }}
        ></label>
        <ButtonLoadCheck
          setProp={props.setProp}
          onClick={handlePreviewButton}
          paramKey={`ClinicAnnualReport_PREVIEW_REPORT`}
          buttonLoadCheck={props.buttonLoadCheck?.[`ClinicAnnualReport_PREVIEW_REPORT`]}
          color="yellow"
          style={{ width: "11rem" }}
          title="Preview"
        />
      </FormGroup>
      <FormGroup className="ui form" style={{ gap: "1rem", padding: "0rem 0rem 0rem 1rem" }}>
        <label style={{ display: "flex", alignItems: "center", padding: "0rem 0.5rem 0rem 0rem" }}>
          วันที่รับบริการ<span style={{ color: "red" }}>*</span>
        </label>
        <DateTextBox
          onChange={(date: string) => {
            props.setProp(`ClinicAnnualReportSequence.clinicIncomeReport.filterStartDate`, date)
            if (props.ClinicAnnualReportSequence?.clinicIncomeReport?.filterStartDate.length < 1) {
              setRequiredStartDate(true);
            } else {
              setRequiredStartDate(false);
            }
          }}
          style={{ width: "11rem" }}
          value={props.ClinicAnnualReportSequence?.clinicIncomeReport?.filterStartDate || ""}
        ></DateTextBox>
        <label style={{ display: "flex", alignItems: "center" }}>{intl.formatMessage({ id: "ถึง" })}</label>
        <DateTextBox
          onChange={(date: string) =>
            props.setProp(`ClinicAnnualReportSequence.clinicIncomeReport.filterEndDate`, date)
          }
          style={{ width: "11rem" }}
          value={props.ClinicAnnualReportSequence?.clinicIncomeReport?.filterEndDate || ""}
        ></DateTextBox>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            padding: "0rem 1rem 0rem 0rem",
          }}
        ></label>
        <ButtonLoadCheck
          setProp={props.setProp}
          onClick={handlePrintButton}
          paramKey={`ClinicAnnualReport_PRINT_REPORT`}
          buttonLoadCheck={props.buttonLoadCheck?.[`ClinicAnnualReport_PRINT_REPORT`]}
          color="blue"
          style={{ width: "11rem" }}
          title={intl.formatMessage({ id: "พิมพ์" })}
        />
      </FormGroup>
      <FormGroup className="ui form" style={{ gap: "1rem", padding: "0rem 0rem 0rem 1rem" }}>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            padding: "0rem 1.15rem 0rem 0rem",
          }}
        >
          ประเภทผู้ป่วย
        </label>
        <Dropdown
          selection={true}
          value={
            props.ClinicAnnualReportSequence?.clinicIncomeReport?.encounterType || "OPD และ IPD"
          }
          onChange={(e: any, data: any) =>
            props.setProp(`ClinicAnnualReportSequence.clinicIncomeReport.encounterType`, data.value)
          }
          options={PATIENT_TYPE}
          style={{ minWidth: "10rem" }}
        ></Dropdown>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            padding: "0rem 16.1rem 0rem 0rem",
          }}
        ></label>
        <ButtonLoadCheck
          setProp={props.setProp}
          onClick={handleDownloadButton}
          paramKey={`ClinicAnnualReport_DOWNLOAD_REPORT`}
          buttonLoadCheck={props.buttonLoadCheck?.[`ClinicAnnualReport_DOWNLOAD_REPORT`]}
          color="green"
          style={{ width: "11rem" }}
          title={intl.formatMessage({ id: "ดาวน์โหลด xlsx" })}
        />
      </FormGroup>
      <FormGroup className="ui form" style={{ gap: "1rem", padding: "0rem 0rem 0rem 1rem" }}>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            padding: "0rem 2.6rem 0rem 0rem",
          }}
        >
          สิทธิรักษา
        </label>
        <Dropdown
          value={props.ClinicAnnualReportSequence?.clinicIncomeReport?.coverageSelected || ""}
          onChange={(e: any, data: any) =>
            props.setProp(
              `ClinicAnnualReportSequence.clinicIncomeReport.coverageSelected`,
              data.value
            )
          }
          placeholder={intl.formatMessage({ id: "เลือกสิทธิ" })}
          options={coverageOptions}
          search={true}
          selection={true}
          style={{ minWidth: "15.5rem" }}
        ></Dropdown>
      </FormGroup>
    </Form>
  );
};

export default CardClinicIncomeReportFilter;
